export const IndicatorColorRange = {
  veryLow: "#008205",
  low: "#000",
  medium: "#000",
  high: "#ff9659",
  veryHigh: "#ff0000",
};
